import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import ClassPage from '../page/ClassPage';
import store from '../configureStore';
import * as frameActions from '../actions/frames';
import * as settingActions from '../actions/settings';
import { getTimeFrameFromDate } from '../utilities/timeUtility';
import ComponentWidgetContainer from './ComponentWidgetContainer';

export default class ClassWidgetContainer extends ComponentWidgetContainer {
  componentDidMount() {
    const {
      exceededBookingsLimit,
      exceededTrialPlan,
      product: { resources },
      rescheduleBookingResources,
    } = this.props;
    const { timeZone } = window.bta;
    const today = new Date();
    const { start, finish } = getTimeFrameFromDate(today, timeZone);
    let resourceId = null;

    if (rescheduleBookingResources) {
      resourceId = resources.find((resource) => resource.id === rescheduleBookingResources[0])?.id;
    }

    if (!exceededBookingsLimit && !exceededTrialPlan) {
      store
        .dispatch(
          frameActions.fetchFrames({
            start: start.format(),
            finish: finish.format(),
            location_id: this.location?.id,
            resource_id: resourceId,
          }),
        )
        .then(
          (framesData) => new Promise((resolve) => {
            if (framesData.nextOccurrence && framesData.frames.length === 0) {
              const params = getTimeFrameFromDate(framesData.nextOccurrence, timeZone);
              store.dispatch(frameActions.fetchFrames(params)).then((framesData2) => {
                resolve(framesData2);
              });
            } else {
              resolve(framesData);
            }
          }),
        );
    }

    super.componentDidMount();
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <ClassPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting({ key, value }));

ClassWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
